import { jsx as _jsx } from "react/jsx-runtime";
import { AlertBanner } from "../../../../components/AlertBanner";
import { useStoreLocatorContext } from "../../../../components/StoreLocator";
import { useTranslations } from "../../../../providers/useTranslations";
export const NoStoresPopup = ({ type, ...rest }) => {
    const { __ } = useTranslations();
    const { handleMapExpansion, handleResetFilters } = useStoreLocatorContext();
    const typeValues = {
        search: {
            title: __("store_locator.noStoresPopup.searchTitle"),
            description: __("store_locator.noStoresPopup.searchDescription"),
            cta: __("store_locator.noStoresPopup.searchCta"),
        },
        filters: {
            title: __("store_locator.noStoresPopup.filtersTitle"),
            description: __("store_locator.noStoresPopup.filtersDescription"),
            cta: __("store_locator.noStoresPopup.filtersCta"),
        },
        location: {
            title: __("store_locator.noStoresPopup.locationTitle"),
            description: __("store_locator.noStoresPopup.locationDescription"),
            cta: __("store_locator.noStoresPopup.locationCta"),
        },
    };
    const handleClickButton = () => {
        if (type === "filters") {
            handleResetFilters();
        }
        else {
            handleMapExpansion();
        }
    };
    return (_jsx("div", { ...rest, children: _jsx(AlertBanner, { title: typeValues[type].title, description: typeValues[type].description, variant: "info", buttonFirstText: typeValues[type].cta, onFirstButtonClick: handleClickButton, withIconClose: false, withVariantIcon: false, shouldCloseOnCtaClick: false }) }));
};
//# sourceMappingURL=NoStoresPopup.js.map